import { useCallback, useState } from 'react';
import { BUDDIES_A, BUDDIES_I, BUDDIES_PAIR, type BuddiesWho } from '@aibuild/ui';

export interface BuddyHandoff {
  readonly thumbnail: BuddiesWho;
  readonly preview: BuddiesWho;
  readonly running: boolean;
  readonly arrived: () => void;
}

type Trip = 'apart' | 'running' | 'joined';

export const useBuddyHandoff = (thumbnailBusy: boolean, buildBusy: boolean): BuddyHandoff => {
  const [trip, setTrip] = useState<Trip>('apart');
  const [wasThumbnailBusy, setWasThumbnailBusy] = useState(thumbnailBusy);

  if (wasThumbnailBusy !== thumbnailBusy) {
    setWasThumbnailBusy(thumbnailBusy);
    if (wasThumbnailBusy && buildBusy) setTrip('running');
  }
  if (!buildBusy && trip !== 'apart') setTrip('apart');

  const arrived = useCallback(() => setTrip('joined'), []);
  const split = thumbnailBusy && buildBusy;
  return {
    thumbnail: split ? BUDDIES_A : BUDDIES_PAIR,
    preview: trip !== 'joined' && (split || trip === 'running') ? BUDDIES_I : BUDDIES_PAIR,
    running: trip === 'running',
    arrived,
  };
};
